/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_One_SecondInputs */



/**
* | output |
* | --- |
* | "Go forward one second in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_one_second = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer d'une seconde dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spulen Sie im Video eine Sekunde vor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai avanti di un secondo nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео на одну секунду вперед.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar un segundo en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频快进一秒。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画を1秒進めます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में एक सेकंड आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avance um segundo no vídeo.")
	return /** @type {LocalizedString} */ ("Go forward one second in the video")
});